// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"0849cc58","841":"0849cc58","885":"0849cc58"}[chunkId] + ".chunk.css";
};